import { useState } from 'react';



export default function Card ({ UXCard }){

  

    const [boxVariant, setBoxVariant] = useState('box');
    const [BoxSize, setBoxSize] = useState('scale(0.95)');
    const [IconTrans, setIconTrans] = useState('scale(0.95');

    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });




    const handleMouseOver = () => {

        setBoxSize('scale(0.99)');
        setIconTrans('scale(1) translate(13px)');

        
    };
    const handleMouseLeave = () => {

        setBoxSize('scale(0.95)');
        setIconTrans('scale(0.95) translateY(0px)');

    };


    const handleMouseMove = (event) => {

        const {currentTarget: target} = event;
        const rect = target.getBoundingClientRect(), 
            x = event.clientX - rect.left,
            y = event.clientY - rect.top;

        document.documentElement.style.setProperty('--mouseX', x+'px');
        document.documentElement.style.setProperty('--mouseY', y+'px');
        
      };

    return (

        
        
        <div className={boxVariant} onMouseOver={handleMouseOver}  onMouseLeave={handleMouseLeave}  onMouseMove={handleMouseMove} style={{ transform: BoxSize }}>

            <div class="box-icon"><img src={UXCard.icon}alt={UXCard.alt} style={{ transform: IconTrans }}/></div>
            <div class="cardTitle">{UXCard.title}</div>
            <div class="cardParag">{UXCard.parag}</div>
            

        </div>
      );
}